<ng-container>
  <div class="container-fluid category list-group">
    <span class="category--parent" tabindex="-1">
      <div class="row ms-4 me-sm-5 mb-4 d-flex justify-content-between align-items-center category">
        <div class="category--header dropdown-mobile--spacer pt-2">
          <span class="ds-heading--s">{{'categories.' + category.translationKey | cxTranslate}}</span>
        </div>
        <img alt="{{category.translationKey}} image" class="ms-3 category--image d-none d-sm-block"
             src="assets/images/header/categories/{{category.translationKey}}.svg">
      </div>
    </span>
    <div #subCategories>
      <span
        (click)="emitEvent(subCategory)"
        (keyup.enter)="emitEvent(subCategory)"
        *ngFor="let subCategory of category.subCategories"
        class="category--subCategory dropdown-mobile--spacer list-group-item list-group-item-action btn ds-cursor--pointer border-none bg-none mb-1"
        tabindex="0">
        <div class="ps-4">
          <span class="ds-body">{{'categories.subCategories.' + subCategory.translationKey | cxTranslate}}</span>
        </div>
      </span>
    </div>
  </div>
</ng-container>
